import React from 'react';
import './App.css';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from 'react-router-dom';
import useApiData from './hooks/useApiData';
import OrganizationView from './components/OrganizationView';
import SearchView from './components/SearchView';

function App() {
  const apiHandler = useApiData();

  return (
    <Router>
      <Switch>
        <Route path="/organisaatio">
          <OrganizationView apiHandler={apiHandler} />
        </Route>

        <Route path="/hakemisto">
          <SearchView apiHandler={apiHandler} />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
